var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-8 pb-0 text-center"},[_c('ProjectByLogos',{staticClass:"hidden-sm-and-down"}),_c('p',{staticClass:"hidden-md-and-up mb-10"},[_vm._v(" "+_vm._s(_vm.$t('A_PROJECT_BY'))+" "+_vm._s(_vm.$t('SUPPORTERS'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }